import { Box, HStack, VStack } from "@chakra-ui/react";
import CDS from "design-system";

interface EmojiEmptyStateProps {
  emoji: string;
  line1: string;
  line2: string;
  bg?: string;
  compact?: boolean;
}

export default function EmojiEmptyState({
  emoji,
  line1,
  line2,
  bg = "gray.50",
  compact = false,
}: EmojiEmptyStateProps) {
  return (
    <Box
      px={compact ? 3 : 4}
      py={compact ? 2.5 : 3}
      bg={bg}
      border="1px solid"
      borderColor="gray.200"
      borderRadius="md"
    >
      <HStack spacing={compact ? 2.5 : 3} align="center">
        <CDS.Text18 fontSize="2xl" lineHeight="1" flexShrink={0}>{emoji}</CDS.Text18>
        <VStack spacing={0} align="flex-start">
          <CDS.Text12 fontWeight="600" color="content.primary">{line1}</CDS.Text12>
          <CDS.Text10 color="content.tertiary">{line2}</CDS.Text10>
        </VStack>
      </HStack>
    </Box>
  );
}
